import { HtmlEditor, Inject, Image, Link, QuickToolbar, RichTextEditorComponent, Toolbar, ToolbarSettingsModel, ToolbarType, QuickToolbarSettingsModel, InlineModeModel, FontFamilyModel, FontSizeModel } from '@syncfusion/ej2-react-richtexteditor';
import { Component, RefObject } from 'react';
import './RichTextEditor.scss'

class RichTextEditor extends Component<IProps, IState>
{
    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
        };
    }

    private get ToolBarSettings(): ToolbarSettingsModel
    {
        return (
            {
                items: 
                [
                    'Bold', 'Italic', 'Underline', 'StrikeThrough',
                    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
                    'LowerCase', 'UpperCase', '|',
                    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
                    'Outdent', 'Indent', '|', 
                    'Undo', 'Redo', '|',
                    'Print', 'SourceCode', '|',
                    'CreateLink', '|', 
                    'Image', '|', 
                ],
                type: ToolbarType.Expand,
            }
        );
    }

    private get quickToolBarSettings(): QuickToolbarSettingsModel
    {
        return (
            {
                image: ['Replace', 'Align', 'Caption', 'InsertLink', 'OpenImageLink', '-', 'RemoveImageLink'],
                link: ['Open', 'UnLink'],
                text: [ 'Alignments', 'Bold', 'Italic', 'Undo', 'Redo' ],
            }
        );
    }

    private get fontFamily(): FontFamilyModel
    {
        return (
            {
                items: 
                [
                    { text: 'Default', value: '' },
                    { text: 'Arial', value: 'Arial,Helvetica,sans-serif' },
                    { text: 'Courier New', value: 'Courier New,Courier,monospace' },
                    { text: 'Georgia', value: 'Georgia,serif' },
                    { text: 'Impact', value: 'Impact,Charcoal,sans-serif' },
                    { text: 'Lucida Console', value: 'Lucida Console,Monaco,monospace' },
                    { text: 'Segoe UI', value: 'Segoe UI' },
                    { text: 'Source Sans Pro', value: 'Source Sans Pro' },
                    { text: 'Tahoma', value: 'Tahoma,Geneva,sans-serif' },
                    { text: 'Times New Roman', value: 'Times New Roman,Times,serif' },
                    { text: 'Trebuchet MS', value: 'Trebuchet MS,Helvetica,sans-serif' },
                    { text: 'Verdana', value: 'Verdana,Geneva,sans-serif' },
                ],
                default: 'Source Sans Pro',
            }
        );
    }

    private get fontSize(): FontSizeModel
    {
        return (
            {
                items: 
                [
                    { text: '8', value: '8pt' },
                    { text: '10', value: '10pt' },
                    { text: '12', value: '12pt' },
                    { text: '14', value: '14pt' },
                    { text: '18', value: '18pt' },
                    { text: '36', value: '36pt' },
                    { text: '42', value: '42pt' }
                ],
                default: '12pt',
            }
           
        );
    }

    public render(): JSX.Element
    {
        return (
            <RichTextEditorComponent
                ref={this.props.editorRef}
                height={450}
                toolbarSettings={this.ToolBarSettings}
                quickToolbarSettings={this.quickToolBarSettings}
                fontFamily={this.fontFamily}
                fontSize={this.fontSize}
                className='syncfusion-rich-text-editor'
            >
                {<div dangerouslySetInnerHTML={{__html: this.props.content}} />}
                <Inject services={[Toolbar, Image, Link, HtmlEditor, QuickToolbar]}/>
            </RichTextEditorComponent> 
        )
    }
}

export default RichTextEditor;

export interface IProps
{
    content: string;
    editorRef: RefObject<RichTextEditorComponent>
}

export interface IState
{
}